<template>
  <px-custom-dialog v-model="dialog" content-class="rounded-card"
                    :width="dialogWidth">
    <template v-slot:activator="{ on }">
      <v-tooltip top>
        <template v-slot:activator="{ on: onTooltip }">
          <v-btn icon
                 :small="small"
                 @mousedown.stop.prevent
                 @click.stop.prevent
                 v-on="{ ...onTooltip, ...on }">
            <v-icon :small="small">mdi-chart-line</v-icon>
          </v-btn>
        </template>
        <span>Histórico do produto</span>
      </v-tooltip>
    </template>
    <template v-slot:title>
      <px-produto-descricao :especificacao="produto.especificacaoProduto"
                            :produto="produto"/>&nbsp;
      <v-btn class="ml-3" icon link target="_blank" :to="linkProduto">
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </template>
    <template>
      <div class="text--primary" v-if="dialog">
        <v-row v-if="unidadeMedida">
          <v-col cols="12">
            <v-card outlined class="rounded-card">
              <v-subheader class="grey lighten-2 text--primary font-weight-bold">
                Histórico de preço por {{ unidadeMedida.descricao }}
              </v-subheader>
              <px-historico-preco-produto :show-title="false"
                                          :unidade-medida="unidadeMedida"
                                          :produto="produto"/>
            </v-card>
          </v-col>
        </v-row>
        <v-row class="text--primary" v-if="showEstoque">
          <v-col cols="12">
            <v-card outlined class="rounded-card">
              <v-subheader class="grey lighten-2 text--primary font-weight-bold">
                Estoque do produto
              </v-subheader>
              <px-listagem-estoque :produto-id="produto.id"/>
            </v-card>
          </v-col>
        </v-row>
        <v-row class="text--primary" v-if="showUltimasCotacoes">
          <v-col cols="12">
            <v-card outlined class="rounded-card">
              <v-subheader class="grey lighten-2 text--primary font-weight-bold">
                Últimas cotações
              </v-subheader>
              <v-divider/>
              <px-ultimas-cotacoes-produto-table :produto="produto"/>
            </v-card>
          </v-col>
        </v-row>
        <v-row class="text--primary" v-if="showUltimasCompras">
          <v-col cols="12">
            <v-card outlined class="rounded-card">
              <v-subheader class="grey lighten-2 text--primary font-weight-bold">
                Últimas compras
              </v-subheader>
              <v-divider/>
              <px-ultimas-compras-produto-table :produto="produto"/>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </template>
  </px-custom-dialog>
</template>

<script>
import ListagemEstoque
  from '@/modules/estoque/ListagemEstoque.vue';
import { mapGetters } from 'vuex';
import UltimasCotacoesProdutoTable
  from '@/modules/cotacao/cotacoes-produtos/UltimasCotacoesProdutoTable.vue';
import UltimasComprasProdutoTable
  from '@/modules/compra/compra-produtos/UltimasComprasProdutoTable.vue';

export default {
  props: {
    produto: {
      type: Object,
      required: true,
    },
    unidadeMedida: {
      type: Object,
      required: false,
    },
    small: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    ...mapGetters('user', ['hasRoleComprador', 'hasRoleAprovadorRequisicao', 'hasRoleAprovador', 'hasRoleRequisicao']),
    ...mapGetters('entidade', ['hasEstoque']),
    isCompradorOuAprovador() {
      return (this.hasRoleComprador
        || this.hasRoleAprovadorRequisicao || this.hasRoleAprovador);
    },
    isRequisitante() {
      return this.hasRoleRequisicao;
    },
    showEstoque() {
      return this.hasEstoque && (this.isCompradorOuAprovador || this.isRequisitante);
    },
    showUltimasCotacoes() {
      return this.isCompradorOuAprovador;
    },
    showUltimasCompras() {
      return this.isCompradorOuAprovador;
    },
    isSmall() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    dialogWidth() {
      return this.isSmall ? '95%' : '1280';
    },
    linkProduto() {
      return `/cadastro-produto/${this.produto.id}`;
    },
  },
  components: {
    pxListagemEstoque: ListagemEstoque,
    pxUltimasCotacoesProdutoTable: UltimasCotacoesProdutoTable,
    pxUltimasComprasProdutoTable: UltimasComprasProdutoTable,
  },
};
</script>
